//  SQL to generate this file - Set SQL query to text output CTRL + T in SQL Server Management Studio
//  (have to remove the leading // )

// SET NOCOUNT ON
// SELECT cast('
// /** '+ cName + ': ' + cDescription + ' */
// export const ' + MuellerGlobalData.dbo.Code_Char_GenerateFromName(cCode) + ' = "' + cCode + '";' as varchar(max))
// FROM MuellerGlobalData.dbo.Features
// ORDER BY cName



/** Agent Code Required: Feature used on ordering a case that makes sure the user entered an agent code */
export const AGENT_CODE_REQUIRED = "AGENT_CODE_REQUIRED";

/** AGENT NO DISPUTES: Determines if an Agent can dispute a case or not */
export const AGENT_NO_DISPUTES = "AGENT_NO_DISPUTES";

/** Allow agents to order cases: Shows an order link on the agent site which allows them to place orders billed to the customer account */
export const AGENT_ALLOW_ORDER = "AGENT_ALLOW_ORDER";

/** Allow Assign to Underwriter: This feature shows Underwriter assignment feature */
export const ALLOW_ASSIGN_UW = "ALLOW_ASSIGN_UW";

/** Allow convert to appraisal: Make the Convert to Appraisal button display in ME */
export const ACE_PDR_CONVERT_TO_APPRAISAL = "ACE_PDR_CONVERT_TO_APPRAISAL";

/** Allow reason for assigning an appraiser: Feature that forces a user to give a reason for assigning an appraiser that has a lower grade than others available */
export const APPRAISER_ASSIGNMENT_REASON = "APPRAISER_ASSIGNMENT_REASON";

/** Allow Remove UW Actions: This feature allows QA Managers and Directors access to a button in NYHOLocal that clears Appraiser Review information. */
export const ALLOW_REMOVE_UW_ACTIONS = "ALLOW_REMOVE_UW_ACTIONS";

/** Allow Web Response to Mailer survey type change: This feature is to flag specific customers who only want to switch a case survey type to Mailer if the current survey type is Web Response */
export const WEBRESPONSE_TO_MAILER = "WEBRESPONSE_TO_MAILER";

/** Alternate ITV Display: This feature shows ITV % in a different way */
export const ALTERNATE_ITV_DISPLAY = "ALTERNATE_ITV_DISPLAY";

/** Appraisal company name: Company name to display. */
export const APPRAISAL_PDF_NAME = "APPRAISAL_PDF_NAME";

/** Appraisal Completed Mark Notifications: Mark specified notification types when appraisal is completed. */
export const APPRAISAL_COMPLETED_RESEND_NOTIFICATION = "APPRAISAL_COMPLETED_RESEND_NOTIFICATION";

/** Appraisal Pdf Custom Footer Text: Custom text to display in the Footer. */
export const APPRAISAL_PDF_FOOTER_TEXT = "APPRAISAL_PDF_FOOTER_TEXT";

/** Appraisal Pdf Header Image: Embedded resource name for the header image. */
export const APPRAISAL_PDF_HEADER_IMAGE = "APPRAISAL_PDF_HEADER_IMAGE";

/** Appraisal Pdf Logo: Embedded resource name for the logo image. */
export const APPRAISAL_PDF_LOGO_IMAGE = "APPRAISAL_PDF_LOGO_IMAGE";

/** Appraisal Port Hold Payment Pending: Places cases on hold and in payment pending status when borrower payment is required until until Appraisal Port indicates payment has been received. */
export const APPRAISAL_PORT_HOLD_PAYMENT_PENDING = "APPRAISAL_PORT_HOLD_PAYMENT_PENDING";

/** Appraisal Port Integration: Settings for Appraisal Port Integration. Note that turning this feature on is not the only thing to do. The customer must also be setup by IT in the AppraisalPortSettings table. */
export const APPRAISAL_PORT_INTEGRATION = "APPRAISAL_PORT_INTEGRATION";

/** Appraiser assignment proximity comment: Require a comment when assigning an appraiser to a subject property more than 150 miles away */
export const APPRAISER_ASSIGNMENT_PROXIMITY_COMMENT = "APPRAISER_ASSIGNMENT_PROXIMITY_COMMENT";

/** Auto-QA Call Center Closeouts: Automatically moves closeouts coming form the call center through QA. */
export const AUTO_QA_CALL_CENTER_CLOSEOUTS = "AUTO_QA_CALL_CENTER_CLOSEOUTS";

/** Based on time of entry apply next day logic to case date received: Adjusts date received to the following business day based upon the time the case was entered into the system */
export const APPLY_NEXT_DAY_BUSINESS_LOGIC_TO_DATE_RECEIVED = "APPLY_NEXT_DAY_BUSINESS_LOGIC_TO_DATE_RECEIVED";

/** Based on time of entry apply next day logic to case due date: Adjusts due date to the following business day based upon the time the case was entered into the system */
export const APPLY_NEXT_DAY_BUSINESS_LOGIC_TO_CASE_DUE_DATE = "APPLY_NEXT_DAY_BUSINESS_LOGIC_TO_CASE_DUE_DATE";

/** Broker Registration: Allows for Broker Registration in Collateral Connect */
export const BROKER_REGISTRATION = "Broker_Registration";

/** Do Not Create case PDF's */
export const CASE_PDF_DO_NOT_CREATE = "CASE_PDF_DO_NOT_CREATE";

/** Cases Available For Immediate Assignment: Case will display on assignment tool even though date received is in the future */
export const CASES_AVAILABLE_FOR_IMMEDIATE_ASSIGNMENT = "CASES_AVAILABLE_FOR_IMMEDIATE_ASSIGNMENT";

/** CC Agent on Email Prenote: CC the agent when sending an email prenote, and notifies them when no policyholder email is found */
export const EMAIL_PRENOTE_CC_AGENT = "EMAIL_PRENOTE_CC_AGENT";

/** Collateral Analytics Risk Profiler: Run Collateral Analytics Risk Profiler when appraisal is submitted to Valuations QA */
export const COLLATERAL_ANALYTICS_RISK_PROFILER = "COLLATERAL_ANALYTICS_RISK_PROFILER";

/** Combine Photo Tags: Feature to combine photo tags through a pipe */
export const COMBINE_PHOTO_TAGS = "COMBINE_PHOTO_TAGS";

/** Copy Stack Code when Copying Case: Copy the stack code when copying the case */
export const COPY_STACK_CODE_CASE_COPY = "COPY_STACK_CODE_CASE_COPY";

/** CS Team Email: Use this email to send automated emails to Customer Service. */
export const CS_TEAM_EMAIL = "CS_TEAM_EMAIL";

/** Customer Case Email: Omit Brand Header: Will omit the brand header row from customer cases emails sent through CaseEmailService. */
export const CUSTOMERCASEEMAIL_OMITBRANDHEADER = "CustomerCaseEmail_OmitBrandHeader";

/** Customer Case Email: Omit Customer Service Contact Info: Will omit the customer service contact info from customer cases emails sent through CaseEmailService. */
export const CUSTOMERCASEEMAIL_OMITCUSTOMERSERVICEINFO = "CustomerCaseEmail_OmitCustomerServiceInfo";

/** Customer Emails Exclude Cancelled Cases: Excludes Cancelled cases from being deliverable via Case Emails */
export const CUSTOMER_EMAILS_EXCLUDE_CANCELLED = "CUSTOMER_EMAILS_EXCLUDE_CANCELLED";

/** Customer Is AMC: Enables the Lender Information section for Web Order V2 and hides Broker ID. */
export const CUSTOMER_IS_AMC = "CUSTOMER_IS_AMC";

/** Data Retention and Deletion: Defines a data retention period for a case's personally identifiable data. */
export const DATA_RETENTION_DELETION = "DATA_RETENTION_DELETION";

/** Default stair counts for customer supplied RCT info: Sets the stair counts to a default value (based on the story number) when importing customer supplied information and no stair count is provided. */
export const DEFAULT_RCT_STAIRS = "DEFAULT_RCT_STAIRS";

/** Disable demotion for cases based on zip code tier: If enabled inspectors will no longer be able to demote cases in the specificed zip code tier(s). Use a comma separated list in the settings if specifying more than one tier. */
export const DISABLE_DEMOTION_BY_TIER = "DISABLE_DEMOTION_BY_TIER";

/** Disable Dispute Case: Turns off the case dispute feature for users */
export const CASE_DISPUTE_DISABLED = "CASE_DISPUTE_DISABLED";

/** Disable Inactive Customer Users: Feature to disable inactive customer user accounts */
export const DISABLE_INACTIVE_CUSTOMER_USERS = "DISABLE_INACTIVE_CUSTOMER_USERS";

/** Disable Mark Case Reviewed: Turns off the mark case reviewed feature for users */
export const CASE_MARK_REVIEWED_DISABLED = "CASE_MARK_REVIEWED_DISABLED";

/** Disable Recommendation Letter: Turns off recommendation letter generation and delivery. */
export const DISABLE_RECOMMENDATION_LETTER = "DISABLE_RECOMMENDATION_LETTER";

/** Disable text messaging: Disable text messaging as a contact method in PhoenixMobile */
export const TEXT_MESSAGING_DISABLED = "TEXT_MESSAGING_DISABLED";

/** Disable Underwriter Comment: Removes the "Review Comments" section from the form InspectorAppform-Abbreviated (which is added to every case via InspectorAppViewPolicyClasses) */
export const DISABLEUNDERWRITERCOMMENT = "DISABLEUNDERWRITERCOMMENT";

/** Disable UW Permission to Extend: Disables UW permission to extend feature on all cases for this customer */
export const UW_PERMISSION_TO_EXTEND_DISABLE = "UW_PERMISSION_TO_EXTEND_DISABLE";

/** Disallow Customer Ordering: Disables the ability for Customers to place online via the Customer Web Site. */
export const DISALLOWCUSTOMERORDERING = "DisallowCustomerOrdering";

/** Display Case Status Tracker: Enables displaying the case status tracker on this accounts case */
export const DISPLAY_CASE_STATUS_TRACKER = "DISPLAY_CASE_STATUS_TRACKER";

/** Display Expected Price for Web Orders: Display the expected price of an order for customers that pay by invoice. */
export const WEB_ORDER_SHOW_EXPECTED_PRICE = "WEB_ORDER_SHOW_EXPECTED_PRICE";

/** Display Header PDF: Shows a custom logo on the PDF reports */
export const DISPLAYHEADERPDF = "DisplayHeaderPDF";

/** Edit RCT Depreciation: Allows editing of replacement cost depreciation multiplier */
export const EDIT_RCT_DEPRECIATION = "EDIT_RCT_DEPRECIATION";

/** Effective date on Mark Reviewed: This will display an effective date entry box for the customer to add when marking a case reviewed.  This feature updates the EffectiveDate field on PolicyHolderDataT. */
export const REVIEWED_EFFECTIVEDATE = "REVIEWED_EFFECTIVEDATE";

/** Email completed report to internet user: This will email the completed cases to the user who placed the order. **Should not be used in Conjunction with "Email completed report to the underwriter DIRECTLY" feature */
export const EMAIL_TO_ORDERING_USER = "EMAIL_TO_ORDERING_USER";

/** Email completed report to the underwriter DIRECTLY: This will email the completed cases to the underwriter directly based upon the underwriter code given. **Should not be used in Conjunction with "Email completed report to internet user" feature. */
export const EMAILUWDIRECTCOMPLETED = "EMAILUWDIRECTCOMPLETED";

/** Email completed reports to underwriter by Agent Code association: This will use the Global Agents table and email the completed reports to the underwriter associated with the Agent. */
export const EMAILUNDERWRITERCOMPLETED = "EMAILUNDERWRITERCOMPLETED";

/** Email with Field Rep Photo: Sends Policyholder an email with a link to a page showing the Field Rep photo */
export const EMAIL_FR_PHOTO = "EMAIL_FR_PHOTO";

/** Endorsed Coverage A Required: Forces underwriter when marking case reviewed to enter a value in the Endorsed Coverage A field when Coverage Change Under Writer Action is selected. */
export const ENDORSEDCOVERAGEAREQUIRED = "EndorsedCoverageARequired";

/** Exclude Case From Management Reports: If enabled, case will not be sent to the warehouse. Used for Non-Real accounts. */
export const EXCLUDE_CASES_MNGMT_REPORTS = "EXCLUDE_CASES_MNGMT_REPORTS";

/** Exclude Cost Breakdown on PDFs ONLY: Excludes the cost breakdown for the calculation on PDF prints ONLY */
export const PDF_EXCLUDE_COST_BREAKDOWN = "PDF_EXCLUDE_COST_BREAKDOWN";

/** Exclude Cost Estimate on PDFs ONLY: Excludes the cost estimate for the calculation on PDF prints ONLY */
export const PDF_EXCLUDE_COST_ESTIMATE = "PDF_EXCLUDE_COST_ESTIMATE";

/** Exclude From Duplicate Report: Exclude From Duplicate Report */
export const EXCLUDE_FROM_DUPLICATE_REPORT = "EXCLUDE_FROM_DUPLICATE_REPORT";

/** Exclude RCT Debris Removal: Excludes debris removal from the total that is transferred to the coverage A form when using the Retrieve button. */
export const RC_WITHOUT_DEBRIS_REMOVAL = "RC_WITHOUT_DEBRIS_REMOVAL";

/** Fannie Mae Appraisal Integration: Settings for Fannie Mae Appraisal Integration */
export const APPRAISAL_INTEGRATION_FNMA = "APPRAISAL_INTEGRATION_FNMA";

/** FNMA Pilot Identifier: Indicates Inspection Types are participating in FNMA Pilot Program */
export const FNMA_PILOT_IDENTIFIER = "FNMA_PILOT_IDENTIFIER";

/** Freddie MAC BACE: Freddie Mac Beyond ACE Integration */
export const FREDDIE_MAC_BACE = "FREDDIE_MAC_BACE";

/** GAAR Appraisal Integration: Submit appraisals to AppraisalPort for Generally Accepted Appraisal Rules */
export const APPRAISAL_INTEGRATION_GAAR = "APPRAISAL_INTEGRATION_GAAR";

/** Generate Agent PDF: Generate an Agent PDF for export */
export const AGENT_PDF = "AGENT_PDF";

/** Generate Policyholder PDF: Generate a Policyholder PDF for export */
export const POLICYHOLDER_PDF = "POLICYHOLDER_PDF";

/** Header - Hide Coverage A Out Exterior: Causes the Coverage A Out to always be hidden in the case header on non-interior cases. */
export const HIDEMUELLERHEADER_COV_A_OUT_EXTERIOR = "HIDEMUELLERHEADER_COV_A_OUT_EXTERIOR";

/** Header - Hide Coverage A Out Interiors: Causes the Coverage A Out to always be hidden in the case header on interior cases. */
export const HIDEMUELLERHEADER_COV_A_OUT_INTERIORS = "HIDEMUELLERHEADER_COV_A_OUT_INTERIORS";

/** Hide case email links: Hide the links to send emails from the case */
export const CASE_EMAIL_LINKS_DISABLED = "CASE_EMAIL_LINKS_DISABLED";

/** Hide Cost Per Sq Ft: Do not show CostPerSQFt on right hand corner of report. */
export const HIDE_COSTPERSQFT = "HIDE_CostPerSQft";

/** Hide County In Standard Report Header: Removes the county from the "Address to Survey" section of the standard report header. */
export const HIDECOUNTYINSTANDARDREPORTHEADER = "HideCountyInStandardReportHeader";

/** Hide Endorsed Coveragte A Out: Hides the endorsed coverage a on the underwriter review form */
export const ENDORSED_COVERAGEA_DISABLED = "ENDORSED_COVERAGEA_DISABLED";

/** Hide GeoCode: Do not show Geocode on left hand corner of report. */
export const HIDE_GEOCODE = "HIDE_Geocode";

/** Hide ITV: Hides the ITV percentage from the PDF output. */
export const RCT_HIDE_ITV = "RCT_HIDE_ITV";

/** Hide Major and Minor Hazard counts: Causes the Major and Minor Hazard counts to be hidden. */
export const HIDE_HAZARD_COUNTS = "HIDE_HAZARD_COUNTS";

/** Hide Markup and Display Section: on the RCT High Valuereport, hide the Markups and Adjustments section */
export const HIDE_MARKUP_AND_ADJUSTMENT_SECTION = "HIDE_MARKUP_AND_ADJUSTMENT_SECTION";

/** Hide Mueller Disclaimer: Does not display the Mueller standard disclaimer at the bottom of the report */
export const HIDEMUELLERDISCLAIMER = "HIDEMUELLERDISCLAIMER";

/** Hide Mueller Header: Does not display the Mueller Header in the final report. */
export const HIDEMUELLERHEADER = "HIDEMUELLERHEADER";

/** Hide Re-Order Link: Hides the ReOrder link for cases on this account */
export const HIDE_REORDERLINK = "HIDE_ReOrderLink";

/** Hide Standard PDF Report: Setup for UWM to hide the standard PDF report when survey type is Property Condition and the order is not Completed */
export const HIDE_STANDARD_REPORT = "HIDE_STANDARD_REPORT";

/** Hide WebNotes: Do not show Special Attention Notes (aka: WebNotes) on bottom of report header. */
export const HIDE_WEBNOTES = "HIDE_WebNotes";

/** HideDataMiningCATUM: Determines if DataMiningCATUM form class should be hidden from final report. */
export const HIDEDATAMININGCATUM = "HideDataMiningCATUM";

/** High Value RCT Billing: Applies an alternate high value calc fee when when the coverage A out exceeds a certain threshold. The threshold is defined by MSB and stored in the General Settings table. */
export const HIGH_VALUE_RCT_BILLING = "HIGH_VALUE_RCT_BILLING";

/** Highlight Hazard Checkbox To Red: Highlights the tick of checkboxes to red for hazards on website and pdf. Does High Value only so far */
export const HIGHLIGHT_HAZARD_REDCHECKBOX = "HIGHLIGHT_HAZARD_REDCHECKBOX";

/** Hold Closeout until Due Date: In the permission to close process, we will keep the case open until the due date instead of closing after 7 days. */
export const HOLD_CLOSEOUT_UNTIL_DUE = "HOLD_CLOSEOUT_UNTIL_DUE";

/** Include Previous Phoenix Data Xml on Case: Includes the last case's Phoenix XML data if there is a match on policynumber. Added under the node /data/previousData */
export const INCLUDE_PREVIOUS_PHOENIX_DATA_XML = "INCLUDE_PREVIOUS_PHOENIX_DATA_XML";

/** Invoice Payment Configuration: If enabled, the customer will be able to pay for orders via Mueller Invoice per the terms of their contract. */
export const INVOICE_PAYMENT_REQUIRED = "INVOICE_PAYMENT_REQUIRED";

/** Invoice PDF Options: Settings related to invoice PDFs */
export const INVOICE_PDF = "INVOICE_PDF";

/** ISOHeader: Customer Header for ISO */
export const ISOHEADER = "ISOHeader";

/** ITV Hazard Rule 2: Under Insured (MAJOR)
- Current coverage is $1 Million or less, and replacement cost is more than 10% of current coverage
- Current coverage is more than $1 Million, and RC is more than a $100,000 of current coverage.

Over Insured (MINOR)
- ("Coverage A In" / "Coverage A Out") * 100 > 150%
- No "Coverage A In" specified */
export const ITV_HAZARD_RULE2 = "ITV_HAZARD_RULE2";

/** ITV Hazard Rule 80-150: If ITV(percent to value) falls between 80-150% then NO hazard (OK)

If ITV(percent to value) falls outside this range flag it as a MAJOR */
export const ITV_HAZARD_80_150 = "ITV_HAZARD_80_150";

/** ITV Out Of Range Hazard: Flags a hazard if the ITV falls outside of the range specified in the feature settings. */
export const ITV_OUT_OF_RANGE_HAZARD = "ITV_OUT_OF_RANGE_HAZARD";

/** ITV_HAZARD_DISPLAYDIFFERENCE: Does not display if the case is overinsured or underinsured it will only display the DIFFERENCE between CoverageAIn and CoverageAOut */
export const ITV_HAZARD_DISPLAYDIFFERENCE = "ITV_HAZARD_DISPLAYDIFFERENCE";

/** Keep MAILER Cases Completed: This Feature is to prevent re-opening a Mailer case received through ScanStation */
export const MAILER_KEEP_COMPLETED = "MAILER_KEEP_COMPLETED";

/** Major company view FR tooltip: Allow certain major companies to view full FR info in tooltip */
export const MAJOR_COMPANY_VIEW_FR_TOOLTIP = "MAJOR_COMPANY_VIEW_FR_TOOLTIP";

/** Minor Hazard Red Text: Shows minor hazards with red text like major hazards */
export const MINOR_HAZARD_REDTEXT = "MINOR_HAZARD_REDTEXT";

/** MSB FIT Upload Photos: If enabled photos should be uploaded to MSB FIT webservice. */
export const MSBFIT_UPLOAD_PHOTOS = "MSBFIT_UPLOAD_PHOTOS";

/** MSB FIT Upload Report PDF: If enabled report PDF should be uploaded to MSB FIT webservice. */
export const MSBFIT_UPLOAD_REPORT = "MSBFIT_UPLOAD_REPORT";

/** MSB FIT Upload Sketch: If enabled the sketch diagram should be uploaded to MSB FIT webservice. */
export const MSBFIT_UPLOAD_SKETCH = "MSBFIT_UPLOAD_SKETCH";

/** Multi-Photo Per Report Page: Feature to support multiple photos per page of Report PDF */
export const MUL_PHOTOS_PER_PAGE = "MUL_PHOTOS_PER_PAGE";

/** Pay Now Payment Configuration: If enabled, the user will be able to pay for orders via credit card at time of order. */
export const PAYNOW_PAYMENT_REQUIRED = "PAYNOW_PAYMENT_REQUIRED";

/** Permission to Close - Default Email: Overrides the underwriter email in the permission to close template. */
export const PERM2CLOSE_DEFAULT_EMAIL = "PERM2CLOSE_DEFAULT_EMAIL";

/** Permission to Close - Send Closeout to QA: In the permission to close process, we will send closeouts to QA instead of automatically moving to complete. */
export const PERM2CLOSE_SEND_CLOSEOUT_TO_QA = "PERM2CLOSE_SEND_CLOSEOUT_TO_QA";

/** Phoenix PDF Overrides: Overrides default text in the Phoenix report. */
export const PHOENIX_PDF_OVERRIDES = "PHOENIX_PDF_OVERRIDES";

/** Phoenix RCT Backfill Highvalue: Indicates that the backfill of PNX RCT data should convert main street to high value. */
export const PNX_RCT_BACKFILL_HIGHVALUE = "PNX_RCT_BACKFILL_HIGHVALUE";

/** Phone Lookup Turn Off: Do not do a phone number lookup */
export const PHONE_LOOKUP_TURN_OFF = "PHONE_LOOKUP_TURN_OFF";

/** Photo - Full Size Photos: Use the full resolution of the photo instead of resizing it. */
export const PHOTO_RESOLUTION_FULLSIZE = "PHOTO_RESOLUTION_FULLSIZE";

/** Photo - Maximum Resolution: Limit the maximum resolution of the photos. */
export const PHOTO_RESOLUTION_MAXIMUM = "PHOTO_RESOLUTION_MAXIMUM";

/** Photo - Use GPS Tagging: Enables GPS tagging for photos in Phoenix */
export const PHOTO_GPS_TAGGING = "PHOTO_GPS_TAGGING";

/** Policyholder Flyer: Include policyholder flyer in policyholder report (currently only implemented in Phoenix PDF). */
export const POLICYHOLDER_FLYER = "POLICYHOLDER_FLYER";

/** Prefer Form Visibility Override - Mainstreet: Overrides the default priority of preferring the customer override */
export const PREFER_FORM_VISIBILITY_OVERRIDE_MAINSTREET = "PREFER_FORM_VISIBILITY_OVERRIDE_MAINSTREET";

/** RCT - Display Only Summary: Causes the RCT form to only display a summary when not in edit mode.  This hides all reference to coverage in and out and only shows the data gathered in the RCT */
export const RCT_DISPLAY_ONLY_SUMMARY = "RCT_DISPLAY_ONLY_SUMMARY";

/** RCT - Hide Cost Breakdown: Causes to RCT form to not display the cost breakdown section when printed or viewed in read mode. */
export const RCT_HIDE_COSTBREAKDOWN = "RCT_HIDE_COSTBREAKDOWN";

/** RCT - Hide Interior Materials On Exterior Only Survey: Hides interior materials when the survey type on the case is is not interior */
export const RCT_HIDEINTERIORMATERIALS_FROM_NONINTERIORSURVEY = "RCT_HIDEINTERIORMATERIALS_FROM_NONINTERIORSURVEY";

/** RCT Allow Custom Items: Enables the Custom Items tab on the RCT 4.x form */
export const RCT_ALLOW_CUSTOM_ITEMS = "RCT_ALLOW_CUSTOM_ITEMS";

/** RCT FIT Single Commit Restriction: Allows only one RCT FIT commit unless the user has the "RCT FIT Commit Unlimited" Right */
export const SINGLE_RCT_FIT_COMMIT = "SINGLE_RCT_FIT_COMMIT";

/** RCT Hide Debris Removal: Hides the debris removal costs RCT High Value ExpressLync/FIT */
export const RCT_HIDE_DEBRISREMOVAL = "RCT_HIDE_DEBRISREMOVAL";

/** RCT Hide Finished Floor Area: Hides the finished floor area on RCT and RCT High Value ExpressLync/FIT */
export const RCT_HIDE_FINISHEDFLOORAREA = "RCT_HIDE_FINISHEDFLOORAREA";

/** RCT Hide NONE Materials from PDF: If NONE is selected as the material, do not display on the PDF */
export const RCT_HIDE_NONE_MATERIALS_PDF = "RCT_HIDE_NONE_MATERIALS_PDF";

/** RCT Override MSB Default Materials: Sends a value of zero for certain materials (when no other value is set) to prevent MSB from using a default value. */
export const RCT_OVERRIDE_MSB_DEFAULT_MATERIALS = "RCT_OVERRIDE_MSB_DEFAULT_MATERIALS";

/** RCT PDF Generation Requires PNX Data: Some fields are to be displayed/hidden based on answers to a PNX Form on the case */
export const RCT_PDF_REQUIRES_PNX_DATA = "RCT_PDF_REQUIRES_PNX_DATA";

/** RCT_ALLOW_MATERIAL_SUBSTITUTION: Does this customer account allow materials to be substituted? */
export const RCT_ALLOW_MATERIAL_SUBSTITUTION = "RCT_ALLOW_MATERIAL_SUBSTITUTION";

/** RCT_LIMIT_ALLOWED_MATERIALS: Does this account limit the RCT materials allowed? */
export const RCT_LIMIT_ALLOWED_MATERIALS = "RCT_LIMIT_ALLOWED_MATERIALS";

/** Send Borrower Broker Email: Enables the broker e-mail to automatically be sent for a case */
export const SEND_BORROWER_BROKER_EMAIL = "SEND_BORROWER_BROKER_EMAIL";

/** Send credit card request to borrower payment configuration: If enabled, the order payment is deferred until credit card payment is received from the borrower/ homeowner. */
export const RETAIL_PAYMENT_REQUIRED = "RETAIL_PAYMENT_REQUIRED";

/** Show Automated Notifications: Prints automated notifications in the PDF below the case header. */
export const SHOW_AUTOMATED_NOTIFICATIONS = "SHOW_AUTOMATED_NOTIFICATIONS";

/** Show Coverage A Out Asterisk: This will show a * next to Coverage A Out indicating the presence of a disclaimer involving Coverage A Out. */
export const SHOW_COVERAGE_A_OUT_ASTERISK = "Show_Coverage_A_Out_Asterisk";

/** Show Filed Rep. Name in Header: This feature adds the Field Rep. name in the report header */
export const SHOW_FR_NAME_ON_HEADER = "SHOW_FR_NAME_ON_HEADER";

/** Show Property Record Data Form: Show form "Public Property Record Data" to the customer */
export const SHOWPROPERTYRECORDDATAFORM = "ShowPropertyRecordDataForm";

/** ShowDataMiningCATUM: Should the data mining CATUM be shown to the customer? */
export const SHOWDATAMININGCATUM = "ShowDataMiningCATUM";

/** Test Feature: This is a feature used for testing features */
export const TESTFEATURE = "TESTFEATURE";

/** UCDP Appraisal Integration: Settings for UCDP Integration */
export const APPRAISAL_INTEGRATION_UCDP = "APPRAISAL_INTEGRATION_UCDP";

/** Underwriter Can Edit Review Comments Before Completed: Allow editing of underwriter comments before the case is in completed status */
export const EDITREVIEWCOMMENTS_BEFORE_COMPLETED = "EDITREVIEWCOMMENTS_BEFORE_COMPLETED";

/** Underwriting Action Taken Required: Makes the Underwriting Action Taken field required when a case is reviewed by a customer */
export const UNDERWRITINGACTIONTAKENREQD = "UNDERWRITINGACTIONTAKENREQD";

/** Underwriting Mark Reviewed Required: Makes the Mark Reviewed button required when a case has an action taken for the first time. */
export const UNDERWRITING_MARK_REVIEWED_REQUIRED = "UNDERWRITING_MARK_REVIEWED_REQUIRED";

/** Use Business Days for Case Date Received: Allow Customer to specify weekends and holidays as non-business days for date received */
export const USE_BUSINESSDAYS_FOR_DATE_RECEIVED = "USE_BUSINESSDAYS_FOR_DATE_RECEIVED";

/** Use Business Days for Case Due Date: Allow Customer to specify weekends and holidays as non-business days */
export const USE_BUSINESSDAYS_FOR_CASEDUEDATE = "USE_BUSINESSDAYS_FOR_CASEDUEDATE";

/** Use specific sender address in customer emails: Feature that allows certain customers to have different sender email on email in case actions ME */
export const CHANGE_SENDER_EMAIL = "CHANGE_SENDER_EMAIL";

/** Validate agent code on Web Orders: This feature will not allow the user to enter invalid/non-existing agent codes when placing an online order. Orders with no agent code are allowed. */
export const VALIDATE_AGENTCODE_ON_WEB_ORDERS = "VALIDATE_AGENTCODE_ON_WEB_ORDERS";

/** Validate Underwriter Code on Web Orders: This feature will not allow the user to enter invalid/non-existing underwriter codes when placing an online order. Orders with no UW Code are allowed. */
export const VALIDATE_UWCODE_ON_WEB_ORDERS = "VALIDATE_UWCODE_ON_WEB_ORDERS";

/** Web Reviewed Cases Show Completed: This feature is to display cases as completed to agents only when the case has been reviewed by the underwriter.  So PolicyHolderDataT.dWebReviewed has been filled in */
export const REVIEWEDASCOMPLETED = "REVIEWEDASCOMPLETED";

/** WEBRESPONSE_AGENTLINK: Should there be a link displayed to automatically log agent into web response cases from agents site? */
export const WEBRESPONSE_AGENTLINK = "WEBRESPONSE_AGENTLINK";